
import { GlobalEventType } from '@/constants'
import { mapGetters } from 'vuex'
/**
 * 关闭页面返回刷新列表
 */
export const CloseToRefreshList = {
  /**
   * 路由离开时，设置目标页是否需要刷新列表
   * @param {*} to
   * @param {*} from
   * @param {*} next
   */
  beforeRouteLeave(to, from, next) {
    const fromNeedRefreshList = from.meta?.needRefreshList
    // needRefreshList 没有定义在data中，是因为它只作为一个普通变量，无需响应式
    if (!this?.needRefreshList && !fromNeedRefreshList) return next()
    to.meta.needRefreshList = this?.needRefreshList || fromNeedRefreshList
    from.meta.needRefreshList = false
    next()
  },
  methods: {
    /**
     * 关闭当前页（跳转到指定页面）
     * @param {string | Location} to 可选参数,与路由对象的`push`方法入参一致，如果未指定 `to`,则默认打开前一个标签
     * @example
     * this.closeSelf('/xxx')
     * this.closeSelf(this.$route)
     * @returns
     */
    async closeSelf(to) {
      await this.$mgCloseEditPageConfirm(this.$route.name)
      const visiteRoutes = this.$store.getters['tabsBar/visiteRoutes']
      if (to && !(to instanceof Event)) {
        let location = this.$router.match(to)
        if (location.path !== this.$route.path) {
          const targetRoute = visiteRoutes.find((item) => item.path === location.path)
          if (targetRoute) location = targetRoute
          this.$store.dispatch('tabsBar/removeTab', this.$route)
          this.$router.push(location)
          return
        }
      }
      // 未指定目标路由走默认逻辑
      const index = visiteRoutes.findIndex((item) => item.path === this.$route.path)
      const toRoute = visiteRoutes[index - 1] || visiteRoutes[index + 1]
      if (toRoute) this.$router.push(toRoute)
      this.$store.dispatch('tabsBar/removeTab', visiteRoutes[index])
    },
  },
}

/**
 * 全局快捷键操作-操作页
 */
export const GlobalKeyboardActionMixinForOperate = {
  activated() {
    this.$GlobalEventBus.on(GlobalEventType.CANCEL, this.keyboardCancelAction)
    this.$GlobalEventBus.on(GlobalEventType.SAVE, this.keyboardSaveAction)
    this.$GlobalEventBus.on(GlobalEventType.AUDIT, this.keyboardAuditAction)
    this.$GlobalEventBus.on(GlobalEventType.RECORDING, this.keyboardRecordingAction)
    this.$GlobalEventBus.on(GlobalEventType.FAST_ADD, this.keyboardFastAddAction)
    this.$GlobalEventBus.on(GlobalEventType.CLEAR_ITEMS, this.keyboardClearItemsAction)
    this.$GlobalEventBus.on(GlobalEventType.PRINT, this.keyboardPrintAction)
    this.$GlobalEventBus.on(GlobalEventType.CUSTOMER_CHANGE, this.keyboardCustomerChange)
    this.$once('hook:deactivated', () => {
      this.$GlobalEventBus.off(GlobalEventType.CANCEL, this.keyboardCancelAction)
      this.$GlobalEventBus.off(GlobalEventType.SAVE, this.keyboardSaveAction)
      this.$GlobalEventBus.off(GlobalEventType.AUDIT, this.keyboardAuditAction)
      this.$GlobalEventBus.off(GlobalEventType.RECORDING, this.keyboardRecordingAction)
      this.$GlobalEventBus.off(GlobalEventType.FAST_ADD, this.keyboardFastAddAction)
      this.$GlobalEventBus.off(GlobalEventType.CLEAR_ITEMS, this.keyboardClearItemsAction)
      this.$GlobalEventBus.off(GlobalEventType.PRINT, this.keyboardPrintAction)
      this.$GlobalEventBus.off(GlobalEventType.CUSTOMER_CHANGE, this.keyboardCustomerChange)
    })
  },
  methods: {
    // 返回列表/取消
    keyboardCancelAction() {
      if (!this.$refs.cancel?.disabled) {
        this.$refs.cancel?.$el.dispatchEvent(new Event('click'))
      }
    },
    // 保存
    keyboardSaveAction() {
      if (!this.$refs.save?.disabled) {
        this.$refs.save?.$el.dispatchEvent(new Event('click'))
      }
    },
    // 审核
    keyboardAuditAction() {
      if (!this.$refs.audit?.disabled) {
        this.$refs.audit?.$el.dispatchEvent(new Event('click'))
      }
    },
    // 入账
    keyboardRecordingAction() {
      if (!this.$refs.recording?.disabled) {
        this.$refs.recording?.$el.dispatchEvent(new Event('click'))
      }
    },
    // 快速添加
    keyboardFastAddAction() {
      if (!this.$refs.fastAddBtn?.disabled) {
        this.$refs.fastAddBtn?.$el.dispatchEvent(new Event('click'))
      }
    },
    // 清空明细
    keyboardClearItemsAction() {
      if (!this.$refs.clearItems?.disabled) {
        this.$refs.clearItems?.$el.dispatchEvent(new Event('click'))
      }
    },
    // 打印
    keyboardPrintAction() {
      if (!this.$refs.print?.disabled) {
        this.$refs.print?.$el.querySelector('button').dispatchEvent(new Event('click'))
      }
    },
    // 更换客户
    keyboardCustomerChange() {
      if (!this.$refs.customerChange?.disabled) {
        this.$refs.customerChange?.$el.dispatchEvent(new Event('click'))
      }
    },
  },
}
/**
 * 全局快捷键操作-列表页
 */
export const GlobalKeyboardActionMixinForList = {
  activated() {
    this.$GlobalEventBus.on(GlobalEventType.ADD, this.keyboardAddAction)
    this.$once('hook:deactivated', () => {
      this.$GlobalEventBus.off(GlobalEventType.ADD, this.keyboardAddAction)
    })
  },
  methods: {
    // 新增
    keyboardAddAction() {
      if (!this.$refs.add?.disabled) {
        this.$refs.add?.$el.dispatchEvent(new Event('click'))
      }
    },
  },
}

/**
 * 组装 cacheKey
 */

export const CacheKey = {
  computed: {
    ...mapGetters({
      belongCode: 'user/belongCode',
      employeeNo: 'user/employeeNo',
    }),

    cacheKey() {
      return (billType, eventType = '') => {
        return [this.belongCode, billType, this.employeeNo, eventType].join('_')
      }
    },
  },
}
/**
 * 全局权限
 */
export const GlobalPermissionMixin = {
  computed: {
    // 是否禁用展示成本价
    isDisabledGlobalPermissionCostPrice() {
      const route = this.$router.match('/globalFiledPermission')
      if (route.name === '404') return true
      return !route.meta?.buttons?.some((n) => n.path === 'costPrice')
    },
  },
}
